import { Injectable, NgZone } from "@angular/core";
import { IMqttMessage, MqttService } from "ngx-mqtt";
import { Observable } from "rxjs";

@Injectable()
export class EventMqttService {
    private endpoint: string;

    constructor(
        private _mqttService: MqttService,
        private readonly zone: NgZone,
    ) {
        this.endpoint = "events";
    }

    topic(projectId: string): Observable<IMqttMessage> {
        const topicName = `/${this.endpoint}/${projectId}`;
        return new Observable<IMqttMessage>((subscriber) => {
            const subscription = this._mqttService.observe(topicName).subscribe({
                next: (message) => this.zone.run(() => subscriber.next(message)),
                error: (error) => this.zone.run(() => subscriber.error(error)),
                complete: () => this.zone.run(() => subscriber.complete()),
            });

            return () => subscription.unsubscribe();
        });
    }
}
